import { DASHBOARD_CHART_TYPES } from "@/shared/constants/GeneralConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "ChartTypeMenu",
  components: {}
})
export default class ChartTypeMenu extends Vue {
  @Prop() stackedCharts!: boolean;

  TOOLTIP = "Tipo Gráfica";
  CHAR_TYPES = DASHBOARD_CHART_TYPES.filter(
    e => e.stacked == this.stackedCharts
  );
  roundBtnClassTertiary = STYLE_CLASSES.TERTIARY_ROUND_BTN;
  currentChartTypeIndex = 0;

  changeChartType(chartType: string) {
    if (chartType == "") {
      chartType = this.CHAR_TYPES[0].value;
    }
    this.$emit("chartTypeChanged", chartType);
  }
}
